export default "__VITE_ASSET__c19deca5__"